import { createFlightSelectorApiClient } from './flight/flightSelectorApiClient'
import { createSelfDriveSelectorApiClient } from './selfdrive/selfDriveSelectorApiClient'

export const flightSelectorApiClient = createFlightSelectorApiClient()
export const selfDriveSelectorApiClient = createSelfDriveSelectorApiClient()
